(() => {
  if (window.__hggStickyAtcLoaded) return;
  window.__hggStickyAtcLoaded = true;

  let frameRequested = false;

  const getNativeButton = (root) => {
    const id = root.dataset.nativeButtonId;
    return id ? document.getElementById(id) : null;
  };

  const getCurrentPrice = (root) => {
    const id = root.dataset.priceContainerId;
    const container = id ? document.getElementById(id) : null;
    if (!container) return null;

    const salePrice = container.querySelector('.price__sale .price-item--last, .price__sale .price-item--sale');
    const regularPrice = container.querySelector('.price__regular .price-item--regular, .price-item--regular');
    const price = salePrice || regularPrice;
    return price ? price.textContent.trim() : null;
  };

  const syncRoot = (root) => {
    const stickyButton = root.querySelector('[data-hgg-sticky-button]');
    const stickyPrice = root.querySelector('[data-hgg-sticky-price]');
    const nativeButton = getNativeButton(root);

    if (!stickyButton || !nativeButton) {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      if (stickyButton) stickyButton.tabIndex = -1;
      return;
    }

    const nativeRect = nativeButton.getBoundingClientRect();
    const shouldShow = nativeRect.bottom <= 0 && window.scrollY > 0;

    root.classList.toggle('is-visible', shouldShow);
    root.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    stickyButton.tabIndex = shouldShow ? 0 : -1;
    stickyButton.disabled = nativeButton.disabled;

    const nativeLabel = nativeButton.querySelector('span')?.textContent.trim();
    stickyButton.textContent = nativeButton.disabled ? (nativeLabel || 'Sold out') : 'Add to Cart';

    const currentPrice = getCurrentPrice(root);
    if (stickyPrice && currentPrice) stickyPrice.textContent = currentPrice;
  };

  const syncAll = () => {
    frameRequested = false;
    document.querySelectorAll('[data-hgg-sticky-atc]').forEach(syncRoot);
  };

  const scheduleSync = () => {
    if (frameRequested) return;
    frameRequested = true;
    requestAnimationFrame(syncAll);
  };

  document.addEventListener('click', (event) => {
    const stickyButton = event.target.closest('[data-hgg-sticky-button]');
    if (!stickyButton) return;

    const root = stickyButton.closest('[data-hgg-sticky-atc]');
    const nativeButton = root ? getNativeButton(root) : null;
    if (nativeButton && !nativeButton.disabled) nativeButton.click();
  });

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  document.addEventListener('change', scheduleSync);
  document.addEventListener('shopify:section:load', scheduleSync);

  const observer = new MutationObserver(scheduleSync);
  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();
